import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';
import { getLibrary } from './redux/actions';
import { Helmet } from 'react-helmet';
import { getFavorites } from './favorites/redux/actions';
import CategoryListPage from './CategoryListPage';
import CategoryDetailPage from './CategoryDetailPage';
import LibraryVideo from './LibraryVideo';
import Loading from '../../common/components/Loading';
import { sendIntercomEvent } from '../../common/events';

class Library extends Component {
  componentDidMount() {
    this.props.dispatch(getLibrary());
    this.props.dispatch(getFavorites());
    sendIntercomEvent('viewed_library');
  }

  render() {
    const { match, categories, favorites } = this.props;

    if (!categories || !favorites) {
      return <Loading />;
    }

    return (
      <div>
        <Helmet>
          <title>Tathata Golf - Library</title>
        </Helmet>
        <Switch>
          <Route exact path={`${match.path}`} component={CategoryListPage} />
          <Route exact path={`${match.path}/:categoryId`} component={CategoryDetailPage} />
          <Route exact path={`${match.path}/:categoryId/videos/:videoId`} component={LibraryVideo} />
          <Redirect to={`${match.path}`} />
        </Switch>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  categories: state.subscription.library.categories.get('data'),
  favorites: state.subscription.favorites.favorites.get('data'),
});

export default connect(mapStateToProps)(Library);



// WEBPACK FOOTER //
// ./src/subscription/library/Library.js